import React from 'react';
import PropTypes from 'prop-types';
import { ForgeScaffold } from '@tylertech/forge-react';
import CommittedChangeButtons from '../CommittedChangeButtons/CommittedChangeButtons.js';
import Title from '../Title/Title.js';
import { SAVE, PREVIOUS } from '../../../static/keyWords.js';
import { useUser } from '../../../contexts/userContext.js';
import './ReusableScaffold.scss';

const ReusableScaffold = ({
  title,
  children,
  headerBadges,
  showGoBackButton = false,
  handleGoBack = () => { },
  headerButtons,
  headerTabButtons,
  activeTab,
  handleTabChange,
  showCommittedChangeButtons = false,
  showCommittedChangeSecondaryButton = false,
  disableCommittedChangeCancelButton = false,
  disableCommittedChangePrimaryButton = false,
  disableCommittedChangeSecondaryButton = false,
  primaryButtonTooltip,
  primaryButtonText = SAVE,
  secondaryButtonText = PREVIOUS,
  handleClickPrimaryButton,
  handleClickSecondaryButton,
  handleClickCancelButton,
  customClasses,
  titleIcon,
  primaryAsSplitButton = false,
  splitButtonOptions = [],
  inlineMessage,

}) => {
  const { user } = useUser();

  return (
    <div slot="body" style={{height: showCommittedChangeButtons ?'calc(100% - 56px)' : '100%'}}>
      <ForgeScaffold className={`forge-example-scaffold ${customClasses}`}>
        <Title
          title={title}
          headerBadges={headerBadges}
          headerButtons={headerButtons}
          headerTabButtons={headerTabButtons}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          showGoBackButton={showGoBackButton}
          handleGoBack={handleGoBack}
          titleIcon={titleIcon}
          inlineMessage={inlineMessage}
        />
        {children}
        {showCommittedChangeButtons && (
          <CommittedChangeButtons
            showCommittedChangeSecondaryButton={showCommittedChangeSecondaryButton}
            disableCommittedChangeCancelButton={disableCommittedChangeCancelButton}
            disableCommittedChangePrimaryButton={disableCommittedChangePrimaryButton || user?.isViewOnly}
            disableCommittedChangeSecondaryButton={disableCommittedChangeSecondaryButton}
            primaryButtonText={primaryButtonText}
            secondaryButtonText={secondaryButtonText}
            handleClickPrimaryButton={handleClickPrimaryButton}
            handleClickSecondaryButton={handleClickSecondaryButton}
            handleClickCancelButton={handleClickCancelButton}
            primaryButtonTooltip={primaryButtonTooltip}
            primaryAsSplitButton={primaryAsSplitButton}
            splitButtonOptions={splitButtonOptions}
          />
        )}
      </ForgeScaffold>
    </div>
  );
};

ReusableScaffold.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  headerBadges: PropTypes.array,
  showGoBackButton: PropTypes.bool,
  handleGoBack: PropTypes.func,
  headerButtons: PropTypes.array,
  headerTabButtons: PropTypes.array,
  activeTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  showCommittedChangeButtons: PropTypes.bool,
  showCommittedChangeSecondaryButton: PropTypes.bool,
  disableCommittedChangeCancelButton: PropTypes.bool,
  disableCommittedChangePrimaryButton: PropTypes.bool,
  disableCommittedChangeSecondaryButton: PropTypes.bool,
  primaryButtonTooltip: PropTypes.string,
  primaryButtonText: PropTypes.string,
  disablePrimaryButton: PropTypes.bool,
  secondaryButtonText: PropTypes.string,
  handleClickPrimaryButton: PropTypes.func,
  handleClickSecondaryButton: PropTypes.func,
  handleClickCancelButton: PropTypes.func,
  customClasses: PropTypes.string,
  titleIcon: PropTypes.string,
  primaryAsSplitButton: PropTypes.bool,
  splitButtonOptions: PropTypes.array,
  inlineMessage: PropTypes.string,
};

export default ReusableScaffold;
